<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <member-form :info="info"/>
      </div>
    </div>
  </section>
</template>

<script>
import memberForm from './Temp/MemberFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '迷客夏',
        type: '飲料'
      }
    }
  },
  components: {
    'member-form': memberForm
  },
  methods: {

  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpMember.vue?1dc43cc0